import { get } from "lodash";
import sessionApi from "../api/session";

const actions = {
  load({ commit }) {
    return sessionApi
      .getSession()
      .then(session => {
        commit("updateSession", session.data);
      })
      .catch(e => {
        console.error(e);
      });
  },
  async login(context, { password, username }) {
    try {
      await sessionApi.login({
        password,
        username,
      });
      await context.dispatch("load");
    } catch (e) {
      // clear session
      throw e;
    }
  },
  async refresh({ dispatch }) {
    await sessionApi.refresh();
    location.reload();
  },
  async updateUserConfiguration({ dispatch }, userConfiguration) {
    const updatedUserConfig = Object.assign(state.user.userConfiguration, userConfiguration);
    const results = await sessionApi.updateUserConfiguration(updatedUserConfig);
    if (results.data) {
      await dispatch("load");
    }
  },
  updateServiceArea(context, serviceArea) {
    return sessionApi.updateServiceArea(serviceArea).catch(e => {
      console.error("Error: Can not update service area", e);
    });
  },
};

const getters = {
  getReleaseNoteFilterList: state => packId => {
    return get(state, `user.userConfiguration.widgets.releaseNoteList.filters.${packId}`, []);
  },
  hasAdminAny: () => state.user.permissions.admin || state.user.permissions.adminOrganization,
  hasAdminOchin: () => state.user.permissions.admin,
  hasAdminOrganization: () => state.user.permissions.adminOrganization,
  hasDashboardAccountManagerView: () => state.user.permissions.dashboardAccountManagerView,
  hasDashboardOrganizationView: () => state.user.permissions.dashboardOrganizationView,
  hasDashboardPersonalView: () => state.user.permissions.dashboardPersonalView,
  hasDashboardQaView: () => state.user.permissions.dashboardQaView,
  hasDashboardUatView: () => state.user.permissions.dashboardUatView,
  hasMemberPackEdit: () => state.user.permissions.memberPackEdit,
  hasPackCreateEdit: () => state.user.permissions.packCreateEdit,
  isOchinUser: () => state.user.isOchinUser,
  hasReleaseNoteCreateEdit: () => state.user.permissions.releaseNoteCreateEdit,
  hasReleaseNoteDelete: () => state.user.permissions.releaseNoteDelete,
  hasReleaseNotePublish: () => state.user.permissions.releaseNotePublish,
  hasReleaseNoteTemplateCreateEdit: () => state.user.permissions.releaseNoteTemplateCreateEdit,
  hasReleaseNoteView: () => state.user.permissions.releaseNoteView,
  hasTestPlanEdit: () => state.user.permissions.testPlanEdit,
  hasTestPlanListView: () => state.user.permissions.testPlanListView,
  hasTestStepCreate: () => state.user.permissions.testStepCreate,
  hasWidgetActivePacksView: () => state.user.permissions.widgetActivePacksView,
  hasWidgetImplementLaterView: () => state.user.permissions.widgetImplementLaterView,
  hasWidgetMyReleaseNoteView: () => state.user.permissions.widgetMyReleaseNoteView,
  hasWidgetPublicationIssuesView: () => state.user.permissions.widgetPublicationIssuesView,
};

const mutations = {
  reset(state) {
    state.expires = null;
    state.loggedIn = false;
    state.serviceArea = null;
    state.serviceAreaList = [];
    state.user = { permissions: {} };
    state.username = "";
  },
  setFilterList(state, { packId, filterList }) {
    if (state.user.userConfiguration.widgets.releaseNoteList) {
      state.user.userConfiguration.widgets.releaseNoteList.filters[packId] = filterList;
    }
  },
  updateServiceAreaList(state, serviceAreaList) {
    state.serviceAreaList = serviceAreaList;
  },
  updateSession(state, session) {
    state.expires = session.expires;
    state.loggedIn = session.loggedIn;
    state.user = session.user;
    state.username = session.username;
    state.serviceArea = session.user.serviceArea;
    state.trainingAgreementAccepted = session.trainingAgreementAccepted;
  },
};

const state = {
  expires: null,
  jwtName: "jwtContinuum",
  loggedIn: false,
  serviceArea: null,
  serviceAreaList: [],
  trainingAgreementAccepted: false,
  theme: {
    primaryColor: "light-blue",
  },
  user: {
    permissions: {},
  },
  username: "",
};

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state,
};
